import './VideoMetadataSkeleton.css';

const videoPlaceholder = 'https://vetric-svc.s3.eu-west-1.amazonaws.com/images/thumbnails/placeholder.svg';
const avatarPlaceholder = 'https://vetric-svc.s3.eu-west-1.amazonaws.com/images/profile_pictures/placeholder.svg';
export default function VideoMetadataSkeleton() {
	return (
		<div id="video-metadata-skeleton" className="skeleton">
			<section style={{ backgroundImage: `url('${videoPlaceholder}')` }} className="image-wrapper" />
			<section className="description">
				<small className="skeleton-element" />
				<small className="skeleton-element" />
				<small className="skeleton-element" />
			</section>
			<section className="channel">
				<img src={avatarPlaceholder} />
				<div>
					<h3 className="skeleton-element" />
					<span className="skeleton-element" />
				</div>
			</section>
			<section className="date">
				<span className="skeleton-element" />
				<span className="skeleton-element" />
			</section>
		</div>
	);
}
